var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAllProductsSelected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 202,
    viewBox: "0 0 204 202",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_952_25245)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102 152.508C130.772 152.508 154.105 129.35 154.105 100.754C154.105 72.1578 130.772 49 102 49C73.2282 49 49.895 72.1578 49.895 100.754C49.895 129.35 73.2282 152.508 102 152.508Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.913 93.9998V125.666C141.913 132.245 136.562 137.596 129.896 137.596H74.2819C67.703 137.596 62.3521 132.333 62.2644 125.754C62.2644 125.666 62.2644 125.666 62.2644 125.579V93.9998C62.2644 93.912 62.2644 93.912 62.2644 93.8243C62.2644 93.6489 62.2644 93.4734 62.3521 93.298C62.4398 93.0349 62.5276 92.8594 62.6153 92.5963L77.5275 64.0876C78.0538 62.9473 79.1941 62.3333 80.4222 62.3333H123.668C124.896 62.3333 125.948 62.9473 126.562 64.0876L141.475 92.5963C141.562 92.7717 141.65 93.0349 141.738 93.298C141.913 93.4734 141.913 93.7366 141.913 93.9998Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.491 94.2629H90.9471C89.9822 94.2629 89.1927 93.5612 89.1927 92.5085V61.7192C89.1927 60.7543 89.8945 59.9648 90.9471 59.9648H113.403C114.368 59.9648 115.158 60.6666 115.158 61.7192V92.5085C115.158 93.4734 114.456 94.2629 113.491 94.2629Z",
    fill: "white",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.947 101.544H83.4914C82.2634 101.544 81.2985 100.491 81.2985 99.3507V69.4386C81.2985 68.2105 82.3511 67.2456 83.4914 67.2456H120.947C122.175 67.2456 123.14 68.2982 123.14 69.4386V99.3507C123.053 100.579 122.175 101.544 120.947 101.544Z",
    fill: "white",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.245 110.052H79.2807C77.9649 110.052 76.8246 108.912 76.8246 107.684V78.2104C76.8246 76.8946 77.9649 75.842 79.2807 75.842H125.245C126.561 75.842 127.702 76.9823 127.702 78.2104V107.596C127.614 109 126.561 110.052 125.245 110.052Z",
    fill: "white",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.894 118.298H74.6314C73.1402 118.298 71.9999 117.07 71.9999 115.754V86.7191C71.9999 85.2279 73.2279 84.1752 74.6314 84.1752H129.894C131.386 84.1752 132.526 85.4033 132.526 86.7191V115.666C132.438 117.158 131.386 118.298 129.894 118.298Z",
    fill: "white",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.315 95.6665H92.5258C91.9995 95.6665 91.4731 95.2279 91.4731 94.6139C91.4731 94.0876 91.9117 93.5612 92.5258 93.5612H113.315C113.841 93.5612 114.368 93.9998 114.368 94.6139C114.368 95.2279 113.929 95.6665 113.315 95.6665Z",
    fill: "#E6ECF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.263 101.807H80.9477C80.5968 101.807 80.3336 101.544 80.3336 101.193C80.3336 100.842 80.5968 100.579 80.9477 100.579H107.176C107.526 100.579 107.79 100.842 107.79 101.193C107.965 101.368 107.702 101.807 107.263 101.807Z",
    fill: "#E6ECF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.544 101.807H111.298C110.947 101.807 110.684 101.544 110.684 101.193C110.684 100.842 110.947 100.579 111.298 100.579H124.456C124.807 100.579 125.07 100.842 125.07 101.193C125.245 101.368 124.982 101.807 124.544 101.807Z",
    fill: "#E6ECF5"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_952_25245)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.336 95.5874V125.61C137.336 129.88 133.92 133.296 129.572 133.296H74.6047C70.3346 133.296 66.8409 129.88 66.8409 125.61V95.4322C66.8409 95.2769 66.8409 95.1216 66.9186 94.9663H81.9884C84.6281 94.9663 86.802 97.0626 86.802 99.7799C86.802 101.1 87.3454 102.342 88.1994 103.196C89.1311 104.128 90.218 104.593 91.6155 104.593H113.516C116.156 104.593 118.33 102.497 118.33 99.7799C118.33 98.46 118.873 97.2178 119.727 96.3638C120.659 95.4322 121.746 94.9663 123.066 94.9663H137.181C137.336 95.1216 137.336 95.3545 137.336 95.5874Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M141.913 93.9998V128.912C141.913 133.736 138.054 137.596 133.141 137.596H71.0363C66.2118 137.596 62.2644 133.736 62.2644 128.912V93.8244C62.2644 93.6489 62.2644 93.4735 62.3521 93.2981H82.352C85.3345 93.2981 87.7906 95.6665 87.7906 98.7366C87.7906 100.228 88.4046 101.631 89.3695 102.596C90.4222 103.649 91.6502 104.175 93.2292 104.175H111.036C114.019 104.175 116.475 101.807 116.475 98.7366C116.475 97.2454 117.089 95.8419 118.054 94.877C119.106 93.8244 120.334 93.2981 121.826 93.2981H141.738C141.913 93.4735 141.913 93.7367 141.913 93.9998Z",
    fill: "white",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.141 124.965H115.071C114.457 124.965 113.93 124.526 113.93 123.824C113.93 123.21 114.369 122.684 115.071 122.684H132.965C133.579 122.684 134.106 123.122 134.106 123.824C134.193 124.35 133.667 124.965 133.141 124.965Z",
    fill: "#E6ECF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.071 130.491H115.071C114.457 130.491 113.93 130.052 113.93 129.351C113.93 128.736 114.369 128.21 115.071 128.21H124.983C125.597 128.21 126.123 128.649 126.123 129.351C126.211 129.877 125.685 130.491 125.071 130.491Z",
    fill: "#E6ECF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.848 134.175C118.497 135.666 117.971 137.245 117.357 138.561C115.69 141.807 113.059 144.35 109.813 146.017C106.48 147.684 102.533 148.386 98.5853 147.508C89.1994 145.491 83.2345 136.456 85.1643 127.158C87.0941 117.859 96.1292 111.807 105.427 113.824C108.761 114.526 111.655 116.193 114.112 118.473C118.322 122.596 119.989 128.473 118.848 134.175Z",
    fill: "#D6DCE8",
    stroke: "#AAB2C5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1191 137.402L99.065 137.457M99.1191 137.402L99.8124 138.097L99.8258 138.11L110.948 126.988L110.241 126.281M99.1191 137.402L110.241 126.281M99.1191 137.402L99.1053 137.389L99.0511 137.443M99.065 137.457L108.091 124.131L108.798 124.838M99.065 137.457L99.0511 137.443M99.065 137.457L99.0511 137.443M110.241 126.281L110.948 125.574L109.505 124.131L108.798 124.838M110.241 126.281L108.798 124.838M108.798 124.838L99.7721 133.864L99.065 134.571L98.3579 133.864L94.6892 130.195L93.2465 131.638L99.0511 137.443M109.505 122.717L108.798 122.01L108.091 122.717L99.065 131.743L95.3963 128.074L94.6892 127.367L93.9821 128.074L91.1252 130.931L90.4181 131.638L91.1252 132.345L98.344 139.564L99.0511 140.271L99.1043 140.218L99.1182 140.232L99.8258 139.524L112.362 126.988L113.069 126.281L112.362 125.574L109.505 122.717Z",
    fill: "white",
    stroke: "#AAB2C5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_952_25245",
    x: 0.89502,
    y: 0,
    width: 202.21,
    height: 201.508,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.513726 0 0 0 0 0.556863 0 0 0 0 0.619608 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_952_25245"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.384314 0 0 0 0 0.403922 0 0 0 0 0.431373 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_952_25245",
    result: "effect2_dropShadow_952_25245"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_952_25245",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_952_25245",
    x: 53.8409,
    y: 78.9663,
    width: 96.4951,
    height: 64.3299,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_952_25245"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_952_25245",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllProductsSelected);
export default __webpack_public_path__ + "static/media/AllProductsSelected.9928e074911c78e7c6df840fcc5f1e4c.svg";
export { ForwardRef as ReactComponent };